import "./index.scss";
import HomeMap from "../../assets/img/Homescreen-full-map.png";
import VerticalLine from "../../components/icons/VerticalLine";
import Logo from "../../components/icons/Logo";
import Touch from "../../assets/img/Blue-Touch-Icon.gif";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../context/DataProvider";
import BeachFront from "../../components/icons/NavIcons/BeachFront";
import InitialEngagement from "../../components/icons/NavIcons/InitialEngagemement";
import Hotel from "../../components/icons/NavIcons/Hotel";
import TennisCourts from "../../components/icons/NavIcons/TennisCourts";
import ConferenceCenterAndBallroom from "../../components/icons/NavIcons/ConferenceCenterAndBallroom";
import OnSiteDining from "../../components/icons/NavIcons/OnSiteDining";
import GolfCourse from "../../components/icons/NavIcons/GolfCourse";
import Spa from "../../components/icons/NavIcons/Spa";
import ContinuousConnections from "../../components/icons/NavIcons/ContinuousConnections";
const LandingPage = () => { 
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash landingPage">
            <div className="home-map">
                <div className="engagement">
                    <InitialEngagement onClick={()=>{
                        _logEvent('click', "Main Map", "Engagement");
                        addFlow("Engagement");
                        navigate("/engagement");
                    }} />
                </div>
                <div className="hotel">
                    <Hotel onClick={()=>{
                        _logEvent('click', "Main Map", "Hotel");
                        addFlow("Hotel");
                        navigate("/hotel");
                    }} />
                </div>
                <div className="tennis">
                    <TennisCourts onClick={()=>{
                        _logEvent('click', "Main Map", "Tennis");
                        addFlow("Tennis");
                        navigate("/tennis");
                    }} />
                </div>
                <div className="conference">
                    <ConferenceCenterAndBallroom onClick={()=>{
                        _logEvent('click', "Main Map", "Conference & Ballroom");
                        addFlow("Conference & Ballroom");
                        navigate("/conference");
                    }} />
                </div>
                <div className="beach">
                    <BeachFront onClick={()=>{
                        _logEvent('click', "Main Map", "Beach");
                        addFlow("Beach");
                        navigate("/beach");
                    }} />
                </div>
                <div className="dining">
                    <OnSiteDining onClick={()=>{
                        _logEvent('click', "Main Map", "Dining");
                        addFlow("Dining");
                        navigate("/dining");
                    }} />
                </div>
                <div className="golf">
                    <GolfCourse onClick={()=>{
                        _logEvent('click', "Main Map", "Golf");
                        addFlow("Golf");
                        navigate("/golf");
                    }} />
                </div>
                <div className="spa">
                    <Spa onClick={()=>{
                        _logEvent('click', "Main Map", "Spa");
                        addFlow("Spa");
                        navigate("/spa");
                    }} />
                </div>
                <div className="continuous">
                    <ContinuousConnections onClick={()=>{
                        _logEvent('click', "Main Map", "Connection");
                        addFlow("Connection");
                        navigate("/connection");
                    }} />
                </div>
            </div>
            <div className="logo" onClick={()=>{
                _logEvent('click', "Main Map", "Agilysys");
                addFlow("Agilysys");
                navigate("/aboutus");
            }}><Logo /></div>
            <div className="top-left">
                <div className="topic-header">
                    Maximize Return on Experience
                    <div className="sub-topic-header">For <strong>Multi Amenity Properties</strong></div>
                </div>
                <div className="column">
                    <div className="row"><span>Delight</span> Guests</div>
                    <div className="row"><span>Retain</span> Staff</div>
                    <div className="row"><span>Grow</span> Margins</div>
                    <div className="line"><VerticalLine /></div>
                </div>
            </div>
            
            <div className="bottom-left">
                <img className="touch-prompt" src={Touch} alt=""/>
                <div className="block">
                    Explore our interactive{'\n'}
                    Multi Amenity map to discover where{'\n'}
                    <span>personal</span> meets <span>profitable</span>{'\n'}
                    <strong>Touch an area to begin!</strong>
                </div>
                
            </div>
            {/*
            <div className="to-engagement link" onClick={()=>{
                _logEvent('click', "Main Map", "Engagement");
                addFlow("Engagement");
                navigate("/engagement");
                }}/>
            <div className="to-hotel link" onClick={()=>{
                _logEvent('click', "Main Map", "Hotel");
                addFlow("Hotel");
                navigate("/hotel");
                }} />
            <div className="to-tennis link" onClick={()=>{
                _logEvent('click', "Main Map", "Tennis");
                addFlow("Tennis");
                navigate("/tennis");
                }} />
            <div className="to-conference link" onClick={()=>{
                _logEvent('click', "Main Map", "Conference & Ballroom");
                addFlow("Conference & Ballroom");
                navigate("/conference");
                }} />
            <div className="to-beach link" onClick={()=>{
                _logEvent('click', "Main Map", "Beach");
                addFlow("Beach");
                navigate("/beach");
                }} />
            <div className="to-dining link" onClick={()=>{
                _logEvent('click', "Main Map", "Dining");
                addFlow("Dining");
                navigate("/dining");
                }} />
            <div className="to-golf link" onClick={()=>{
                _logEvent('click', "Main Map", "Golf");
                addFlow("Golf");
                navigate("/golf");
                }} />
            <div className="to-spa link" onClick={()=>{
                _logEvent('click', "Main Map", "Spa");
                addFlow("Spa");
                navigate("/spa");
                }} />
            <div className="to-connection link" onClick={()=>{
                _logEvent('click', "Main Map", "Connection");
                addFlow("Connection");
                navigate("/connection");
                }} />
                 */}
        </div>
    )
}
export default LandingPage;